import { DatePipe, NgClass } from '@angular/common';
import {
  booleanAttribute,
  ChangeDetectionStrategy,
  Component,
  computed, inject,
  input,
  output,
} from '@angular/core';
import { RouterModule } from '@angular/router';

import { TranslateModule } from '@ngx-translate/core';
import { IconModule, ImageModel } from '@hglobal/common';
import { ImageLoaderDirective } from '@pt/directives';
import { ArticleType, NewsCategory, NewsSubcategory } from '@pt/models';
import { getRouterLinkForArticle } from '@pt/helpers';
import { GoogleAnalyticsService } from '@pt/services';

export interface ArticleCardItem {
  id: number;
  slug?: string;
  title: string;
  previewImage: ImageModel;
  image: ImageModel;
  previewText: string;
  publishedAt: string;
  articleType: ArticleType;
  read?: boolean;
  saved?: boolean;
  commentsCount?: number;
  minutesToRead?: string;
  category?: NewsCategory;
  subcategory?: NewsSubcategory;
}

@Component({
  selector: 'pt-article-card, [ptArticleCard]',
  imports: [RouterModule, TranslateModule, IconModule, ImageLoaderDirective, NgClass, DatePipe],
  templateUrl: './article-card.component.html',
  styleUrls: ['./article-card.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ArticleCardComponent {
  item = input.required<ArticleCardItem>();
  widget = input(false, { transform: booleanAttribute });
  link = input<string>();
  toggleSaved = output<void>();
  queryParams = computed(() => {
    const category = this.item().category;

    return category ? { categoryId: category.id, categoryName: category.name } : {};
  });
  readonly #googleAnalyticsService = inject(GoogleAnalyticsService);

  get routerLink(): (string | number)[] {
    if (this.item().articleType !== 'blog') {
      return getRouterLinkForArticle(this.link(), this.item());
    }

    return ['/blog', this.item().id];
  }

  onArticleClick(): void {
    this.#googleAnalyticsService.pushCustomEvent(
      'home',
      this.item().articleType === 'blog' ? 'blog' : 'news',
      {
        element_name: 'article_click', type: 'big_card',
        url: `${this.routerLink.join('/')}`,
      },
    );
  }
}
